import { Device } from '@capacitor/device'

/**
 * Which handset sent an upload, for diagnostics in the admin.
 *
 * The API already reads the client family from the User-Agent, so all this adds
 * is the model — the part a User-Agent cannot give. It is a model, never an
 * individual device: two identical iPhones report the same string, which is
 * exactly the line we do not want to cross.
 */
export const MAX_SOURCE_DEVICE_LENGTH = 64

let cached = null

const normalize = (value) => {
    if (typeof value !== 'string') return null

    const text = value.replace(/\s+/g, ' ').trim()

    return text === '' ? null : text.slice(0, MAX_SOURCE_DEVICE_LENGTH)
}

/**
 * Exported on its own so the shaping can be tested without a native bridge.
 */
export const buildSourceDevice = (info) => {
    const model = normalize(info?.model)
    const os = normalize([info?.operatingSystem, info?.osVersion].filter(Boolean).join(' '))

    return normalize([model, os].filter(Boolean).join(' / '))
}

export const resolveUploadSourceDevice = async () => {
    if (cached !== null) return cached

    try {
        cached = buildSourceDevice(await Device.getInfo())
    } catch {
        // Never worth failing an upload over: the API treats this field as a
        // hint and stores nothing when it is absent.
        cached = null
    }

    return cached
}

/**
 * Appends the field only when we have something to say, so an upload from a
 * browser stays exactly as it was.
 */
export const appendUploadSourceDevice = async (formData) => {
    const device = await resolveUploadSourceDevice()

    if (device) {
        formData.append('source_device', device)
    }

    return formData
}
